import { ButtonLink } from '../ui/Button'
import { Card, SectionTitle } from '../ui/Card'

export function OrgQuickLinksWidget() {
  return (
    <Card>
      <SectionTitle>Quick Links</SectionTitle>
      <div className="flex gap-3 flex-wrap">
        <ButtonLink to="/clients">View Clients</ButtonLink>
        <ButtonLink to="/appointments" variant="outline">View Appointments</ButtonLink>
        <ButtonLink to="/invoices" variant="outline">View Invoices</ButtonLink>
      </div>
    </Card>
  )
}
